import makeStyles from '@mui/styles/makeStyles';

const defaultColorBlue = "#308CDB";
const defaultColorText = "#465869";

const styles = makeStyles(() => ({
  headerTitle: {
    font: "700 14px/21px Manrope",
    color: defaultColorBlue,
  },
  headerAddress: {
    font: "500 14px/24px Manrope",
    color: "#465869",
    marginTop: 4,
  },
  box: {
    padding: ".5rem",
    background: "white",
    borderRadius: "8px",
    border: "1px solid #C4C4C4",
    marginTop: "10px",
  },
  map: {
    height: "300px",
    width: "100%",
  },
  accessInfoWrapper: {
    marginTop: 20,
  },
  accessInfoLabel: {
    font: "700 16px/18px Manrope",
    color: defaultColorBlue,
    marginBottom: 16,
  },
  accessInfoSpan: {
    font: "500 14px/18px Manrope",
    color: defaultColorText,
    textTransform: "capitalize",
  },
  parkingTypeLabel: {
    font: "600 14px/24px Manrope",
    color: defaultColorBlue,
    marginBottom: 5,
  },
  parkingTypeValue: {
    font: "500 14px/24px Manrope",
    color: defaultColorText,
  },
}));

export default styles;
